import type { PdfTemplate } from "../types";

/**
 * Hello World PDF Template (English)
 *
 * A simple introductory template demonstrating the basic structure
 * of a PDF template with text, heading, and divider components.
 */
export const helloWorld: PdfTemplate = {
  key: "hello-world",
  category: "basic",
  language: "en_GB",
  name: "Hello World",
  description:
    "A simple introductory template demonstrating basic PDF structure with headings, text, and dividers.",
  badges: ["Basic", "1 Section", "1 Page"],

  // Default styling
  fontFamily: "Inter",
  fontSize: 11,
  tableStyleType: "borders",

  sections: [
    {
      name: "Introduction",
      scope: "global",
      order: 0,

      // Header with line
      headerText: "Sample Document",
      headerTextAlign: "left",
      headerShowLine: true,
      headerLineColor: "#e5e5e5",

      // Footer with page numbers
      footerShowNumbers: true,
      footerShowLine: true,
      footerLineColor: "#e5e5e5",

      pages: [
        {
          name: "Welcome",
          order: 0,
          components: [
            {
              type: "heading",
              order: 0,
              config: { title: "Hello World" },
            },
            {
              type: "spacer",
              order: 1,
              config: { height: 20 },
            },
            {
              type: "text",
              order: 2,
              config: {
                content:
                  "Welcome to your first PDF template. This document demonstrates the basic building blocks available for creating professional PDF documents.",
                align: "left",
              },
            },
            {
              type: "spacer",
              order: 3,
              config: { height: 30 },
            },
            {
              type: "heading",
              order: 4,
              config: { title: "Getting Started" },
            },
            {
              type: "text",
              order: 5,
              config: {
                content:
                  "You can customize this template by adding more sections, pages, and components. Available component types include:",
                align: "left",
              },
            },
            {
              type: "spacer",
              order: 6,
              config: { height: 10 },
            },
            {
              type: "text",
              order: 7,
              config: {
                content:
                  "• Headings - For titles and section headers\n• Text - For paragraphs and descriptions\n• Spacers - For controlling vertical spacing\n• Tables - For structured data display\n• Field Values - For dynamic client/flow data\n• Page Breaks - For controlling pagination",
                align: "left",
              },
            },
            {
              type: "spacer",
              order: 8,
              config: { height: 20 },
            },
            {
              type: "text",
              order: 9,
              config: {
                content:
                  "Edit this template to customize the content, styling, and layout to match your needs.",
                align: "center",
              },
            },
          ],
        },
      ],
    },
  ],
};
